import router from './router'
import { useAppStoreWithOut } from '@/store/modules/app'
import type { RouteRecordRaw } from 'vue-router'
import { useTitle } from '@/hooks/web/useTitle'
import { useNProgress } from '@/hooks/web/useNProgress'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { usePageLoading } from '@/hooks/web/usePageLoading'
import { NO_REDIRECT_WHITE_LIST } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { ref } from 'vue'
import { getUserInfoApi } from './api/login'

const { start, done } = useNProgress()

const { loadStart, loadDone } = usePageLoading()

const showProgress = ref(false)
router.beforeEach(async (to, from, next) => {
  if (to.name !== 'Login') {
    // const configStore = useConfigStore()
    // configStore.inSureConfig()
  }
  if (showProgress.value) {
    start()
  }
  loadStart()
  const permissionStore = usePermissionStoreWithOut()
  const appStore = useAppStoreWithOut()
  const userStore = useUserStoreWithOut()
  if (userStore.getUserInfo) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (permissionStore.getIsAddRouters) {
        next()
        return
      }

      // 开发者可根据实际情况进行修改
      const roleRouters = []
      // 是否使用动态路由
      if (appStore.getDynamicRouter) {
        let permissions = userStore.getPermissions
        await getUserInfoApi().then((res) => {
          if (!res) {
            return
          }
          permissions = (res.data['permissions'] as Record<string, string[]>) || permissions
          const headImg = (res.data['head_img'] as string) || ''
          const storeName = (res.data['store_name'] as string) || ''
          const userName = (res.data['username'] as string) || ''
          const config = (res.data['config'] as any) || {}
          const expire = (res.data['expire'] as string) || ''
          userStore.setPermissions(permissions)
          userStore.setHeadImg(headImg)
          userStore.setStoreName(storeName)
          userStore.setUserName(userName)
          userStore.setConfig(config)
          userStore.setExpire(expire)
          userStore.setDataAuth(res.data['data_auth'] as string)
          userStore.setStoreOptions(res.data['store_options'] as any[])
          userStore.setTableColumns(res.data['table_columns'] as Record<string, any[]>)
        })
        appStore.serverDynamicRouter
          ? await permissionStore.generateRoutes(
              'server',
              roleRouters as AppCustomRouteRecordRaw[],
              permissions
            )
          : await permissionStore.generateRoutes('frontEnd', roleRouters as string[], permissions)
      } else {
        await permissionStore.generateRoutes('static')
      }

      permissionStore.getAddRouters.forEach((route) => {
        router.addRoute(route as unknown as RouteRecordRaw) // 动态添加可访问路由表
      })
      const redirectPath = from.query.redirect || to.path
      const redirect = decodeURIComponent(redirectPath as string)
      const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect }
      permissionStore.setIsAddRouters(true)
      next(nextData)
    }
  } else {
    if (NO_REDIRECT_WHITE_LIST.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
    }
  }
})

router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  if (showProgress.value) {
    done() // 结束Progress
  }
  loadDone()
})
